// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1456":"963bca1db25e285f","1660":"963bca1db25e285f","2888":"827a9a187a022791","3540":"c96498935b3b3b6f","3814":"e1f441b2974ba220","8691":"c96498935b3b3b6f"}[chunkId] + ".css";
};